export default __webpack_public_path__ + "static/realWorldImg5-6a7c51baa1538b79dcc9810f58f98a51.webp";